import React from 'react'
import { Typography } from '@material-ui/core'
import veiculoDenatranRepository from './VeiculoDenatranRepository'
import RequisicaoCard from '../RequisicaoCard'
import moment from 'moment'
import { normalizeAndEqualizeString } from '../../../../utils/Utils'

const VeiculoDenatranCard = ({
  match,
  placa,
  codRenavam,
  cpfcnpj,
  disabled,
  validData,
  warningMessage,
  validateFieldName,
  chassi,
  ano,
  modelo,
  municipio,
  nomeProprietario
}) => {
  const transform = query => ({
    ...query,
    placa,
    codRenavam,
    cpfcnpj
  })

  const validateData = data => {
    if (data) {
      const isSameChassi = data.chassi === chassi

      const isSameAnoModelo =
        data.anoModelo === ano &&
        normalizeAndEqualizeString(data.descricaoMarcaModelo)
          .replace(/\s/g, '')
          .includes(normalizeAndEqualizeString(modelo).replace(/\s/g, ''))

      const normalizedFormMunicipio = normalizeAndEqualizeString(municipio)
      const normalizedDataMunicipio = normalizeAndEqualizeString(
        data.descricaoMunicipioEmplacamento
      )
      const isSameMunicipio =
        normalizedDataMunicipio === normalizedFormMunicipio

      const normalizedFormNomeProprietario = normalizeAndEqualizeString(
        nomeProprietario
      )
      const normalizedDataNomeProprietario = normalizeAndEqualizeString(
        data.nomeProprietario
      )
      const isSameNomeProprietario =
        normalizedDataNomeProprietario === normalizedFormNomeProprietario

      const isSituacaoEmCirculacao = data.situacao === 'EM CIRCULACAO'

      let message = ''

      if (!isSameChassi) {
        message += 'Chassi não confere. '
      }

      if (!isSameAnoModelo) {
        message += 'Ano/Modelo não confere. '
      }

      if (!isSameMunicipio) {
        message += 'Município não confere. '
      }

      if (!isSameNomeProprietario) {
        message += 'Nome do proprietário não confere. '
      }

      if (!isSituacaoEmCirculacao) {
        message += 'Veículo não está em circulação. '
      }

      if (!isSituacaoEmCirculacao) {
        return { status: 'ERROR', message: 'Veículo não está em circulação.' }
      }

      if (
        isSameChassi &&
        isSameAnoModelo &&
        isSameMunicipio &&
        isSameNomeProprietario &&
        isSituacaoEmCirculacao
      ) {
        return { status: 'SUCCESS', message: '' }
      }

      if (
        !isSameChassi ||
        !isSameAnoModelo ||
        !isSameMunicipio ||
        !isSameNomeProprietario
      ) {
        return { status: 'WARNING', message: message.trim() }
      }
    }

    return { status: 'ERROR', message: '' }
  }

  return (
    <RequisicaoCard
      validateFieldName={validateFieldName}
      title="DENATRAN"
      match={match}
      repository={veiculoDenatranRepository}
      transformQuery={transform}
      transformManualFetch={transform}
      disabled={disabled}
      validData={validData}
      validateData={validateData}
      warningMessage={warningMessage}
    >
      {data => (
        <>
          {!!data.placa && (
            <Typography>
              <b>Placa:</b> {data.placa}
            </Typography>
          )}
          {!!data.situacao && (
            <Typography>
              <b>Situação:</b> {data.situacao}
            </Typography>
          )}
          {!!data.anoModelo && (
            <Typography>
              <b>Ano modelo:</b> {data.anoModelo}
            </Typography>
          )}
          {!!data.anoFabricacao && (
            <Typography>
              <b>Ano fabricação:</b> {data.anoFabricacao}
            </Typography>
          )}
          {!!data.descricaoTipoCarroceria && (
            <Typography>
              <b>Carroceria:</b> {data.descricaoTipoCarroceria}
            </Typography>
          )}
          {!!data.descricaoEspecieVeiculo && (
            <Typography>
              <b>Espécie:</b> {data.descricaoEspecieVeiculo}
            </Typography>
          )}
          {!!data.descricaoMarcaModelo && (
            <Typography>
              <b>Marca/Modelo:</b> {data.descricaoMarcaModelo}
            </Typography>
          )}
          {!!data.descricaoTipoVeiculo && (
            <Typography>
              <b>Tipo:</b> {data.descricaoTipoVeiculo}
            </Typography>
          )}
          {!!data.descricaoRemarcacaoChassi && (
            <Typography>
              <b>Remarcação Chassi:</b> {data.descricaoRemarcacaoChassi}
            </Typography>
          )}
          {!!data.descricaoMunicipioEmplacamento && (
            <Typography>
              <b>Município emplacamento:</b>{' '}
              {data.descricaoMunicipioEmplacamento}
            </Typography>
          )}
          {!!data.descricaoCategoria && (
            <Typography>
              <b>Categoria:</b> {data.descricaoCategoria}
            </Typography>
          )}
          {!!data.descricaoCor && (
            <Typography>
              <b>Cor:</b> {data.descricaoCor}
            </Typography>
          )}
          {!!data.potencia && (
            <Typography>
              <b>Potência:</b> {data.potencia}
            </Typography>
          )}
          {!!data.cilindradas && (
            <Typography>
              <b>Cilindradas:</b> {data.cilindradas}
            </Typography>
          )}
          {!!data.descricaoCombustivel && (
            <Typography>
              <b>Combustível:</b> {data.descricaoCombustivel}
            </Typography>
          )}
          {!!data.numMotor && (
            <Typography>
              <b>Motor:</b> {data.numMotor}
            </Typography>
          )}
          {!!data.chassi && (
            <Typography>
              <b>Chassi:</b> {data.chassi}
            </Typography>
          )}
          {!!data.lotacao && (
            <Typography>
              <b>Lotação:</b> {data.lotacao}
            </Typography>
          )}
          {!!data.cmc && (
            <Typography>
              <b>CMC:</b> {data.cmc}
            </Typography>
          )}
          {!!data.nomeProprietario && (
            <Typography>
              <b>Proprietário:</b> {data.nomeProprietario}
            </Typography>
          )}
          {!!data.descricaoTipoProprietario && (
            <Typography>
              <b>Tipo Proprietário:</b> {data.descricaoTipoProprietario}
            </Typography>
          )}
          {!!data.nomeArrendatario && (
            <Typography>
              <b>Arrendatário:</b> {data.nomeArrendatario}
            </Typography>
          )}
          {data.indicadorRestricaoRenajud && (
            <>
              <Typography>
                <b>
                  <i>Indicador Restrição Renajud</i>
                </b>
              </Typography>
              {[...Array(4).keys()].map(
                (_, i) =>
                  data[`descricaoRestricao${i + 1}`] && (
                    <Typography key={i}>
                      <b>Restrição {i + 1}:</b>{' '}
                      {data[`descricaoRestricao${i + 1}`]}
                      {' - '}
                      <b>Código:</b> {data[`codRestricao${i + 1}`]}
                    </Typography>
                  )
              )}
            </>
          )}
          {data.indicadorRecall && (
            <Typography>
              <b>
                <i>Indicador Recall</i>
              </b>
            </Typography>
          )}
          {[...Array(4).keys()].map(
            (_, i) =>
              data[`indicadorRecall${i + 1}`] && (
                <Typography key={i}>
                  <b>Indicador Recall {i + 1}: </b>
                  {data[`indicadorRecall${i + 1}`]}
                </Typography>
              )
          )}
          {data.indicadorLeilao && (
            <Typography>
              <b>Indicador Leilão</b>
            </Typography>
          )}
          {!!data.indicadorRouboFurto && (
            <Typography>
              <b>Indicador Roubo</b>
            </Typography>
          )}
          {data.indicadorAlarme && (
            <Typography>
              <b>Indicador Alarme</b>
            </Typography>
          )}
          {data.indicadorComunicacaoVenda && (
            <Typography>
              <b>Indicador Comunicação Venda</b>
            </Typography>
          )}
          {data.indicadorPendenciaEmissao && (
            <Typography>
              <b>Indicador Pendência Emissão</b>
            </Typography>
          )}
          {data.indicadorMultaRenainf && (
            <Typography>
              <b>Indicador Multa RENAINF</b>
            </Typography>
          )}
          {data.renajud && (
            <>
              <Typography>
                <b>
                  <i>RENAJUD</i>
                </b>
              </Typography>
              <Typography>
                <b>Quantidade real:</b> {data.renajud.qtdReal}
              </Typography>
              <Typography>
                <b>Quantidade retornada:</b> {data.renajud.qtdRetornada}
              </Typography>
              {data.renajud.processos &&
                data.renajud.processos.map(processo => (
                  <div style={{ paddingLeft: 12 }} key={processo.id}>
                    <Typography>
                      <b>
                        {processo.nomeOrgaoJudicial} -{' '}
                        {processo.codOrgaoJudicial}
                      </b>
                    </Typography>
                    <Typography>
                      <b>
                        {processo.nomeTribunal} - {processo.codTribunal}
                      </b>
                    </Typography>
                    <Typography>
                      <b>Número processo:</b> {processo.numProcesso}
                    </Typography>
                    <Typography>
                      <b>Restrições ativas:</b> {processo.qtdRestricoesAtivas}
                    </Typography>
                    {processo.restricoes &&
                      processo.restricoes.map(restricao => (
                        <div style={{ paddingLeft: 12 }} key={restricao.id}>
                          <Typography>
                            <b>Restrição:</b> {restricao.descricaoRestricao} -{' '}
                            {moment(restricao.dataInclusaoRestricao).format(
                              'DD/MM/YYYY'
                            )}
                          </Typography>
                        </div>
                      ))}
                  </div>
                ))}
            </>
          )}
        </>
      )}
    </RequisicaoCard>
  )
}

export default React.memo(VeiculoDenatranCard)
